import { PiCaretRight } from 'react-icons/pi';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { Text } from 'src/modules/shared/components/atoms/text';
import Tooltip from 'src/modules/shared/components/atoms/tooltips/tooltip';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

export const ConversationHeaderTitleButton = ({
  contactId,
  conversationName,
  onOpenProfile,
}: {
  contactId?: number;
  conversationName: string;
  onOpenProfile: (contactId: number) => void;
}) => {
  const { t } = useI18n();

  return (
    <div className="min-w-0 w-full max-w-[240px]">
      <Tooltip
        content={t('communications.conversationHeader.viewContactProfile')}
        placement="bottom"
        size="sm"
        contentClassName="min-w-0 w-full justify-start"
      >
        <Button
          variant="primary"
          appearance="ghost"
          onClick={() => onOpenProfile(contactId ?? 0)}
          className="h-auto min-w-0 w-full !justify-start gap-1 overflow-hidden px-0 py-0.5 text-left"
        >
          <Text
            size="h6"
            className="min-w-0 flex-1 truncate text-left"
            weight="regular"
            color="primary"
          >
            {conversationName}
          </Text>

          <PiCaretRight className="h-4 w-4 flex-shrink-0" />
        </Button>
      </Tooltip>
    </div>
  );
};
